import React, { Component } from 'react';
import * as actionCreators from '../store/actions';
import { connect } from 'react-redux';

class ExportView extends Component {
  render() {
    return (
      <div><a href="/api/visitors/export/csv">Download</a></div>
    );
  }
}

const selector = (state) => ({tabs: state.tabs});
export const ExportComponent = connect(selector, actionCreators)(ExportView);



// WEBPACK FOOTER //
// ./src/components/export.js